
import AvatarBadge from '../UI/Auth/AvatarBadge.vue'
import {defineComponent} from "vue"
export default defineComponent({
    name: 'AppSidebar',
    components: { AvatarBadge },
    data: () => ({
        links: [
            {   
                label: 'Сохранённые сообщения',
                icon: 'fa-solid fa-save',
                callback: 'onSaveTap'
            },
            {   
                label: 'Пользователь',
                icon: 'fa-solid fa-user',
                callback: 'profileEdit'
            },
            {   
                label: 'Друзья',
                icon: 'fa-solid fa-handshake',
            },
            {   
                label: 'Настройки',
                icon: 'fa-solid fa-gear',
                callback: 'configure'
            }
        ],
        footerBtns: [
            {   
                label: 'Что это такое?',
                icon: 'fa-solid fa-circle-question',
                callback: ''
            },
            {   
                label: 'Пригласить друзей',
                icon: 'fa-solid fa-bullhorn',
                callback: ''
            },
            {   
                label: 'Выход',
                icon: 'fa-solid fa-arrow-right-from-bracket',
                callback: 'logout',
                exact: false
            }
        ]
    }),
    methods: {
        async logout(): Promise<void> {
            this.$router.push({name: "login", query: {
                message: "auth/session-closed"
            }}).then(async ()=>{
                await this.$store.dispatch('auth/logout')
            })
        },
        profileEdit(): void {
            this.$router.push({name: 'profile-edit', params: {uid: this.user.uid}})
        },
        onClick(link): void {
            if(link.name) {
                this.$router.push({ name: link.name, })
            }
            else if( this[link.callback] ) this[link.callback]()
            else {
                this.$toast.show(link.label)
            }
        }
    },
    computed: {
        user() {
            return this.$store.getters['auth/getUser']
        }
    }
})
